import React from 'react';
import USBLoader from '@usb-shield/react-loader';
import './style.scss';

const Loader = () => (
    <div id="fallback-loader" role="alert" aria-live="assertive">
        <USBLoader determinate={false} variant="simple" />
    </div>
);

export default Loader;
